
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';
import { TYTCommonModule } from '@tytapp/common';

import { ArticleComponent } from './article/article.component';
import { ArticlesComponent } from './articles/articles.component';
import { routing } from './article-pages.routing';
import { CommonUiModule } from '@tytapp/common-ui';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { UserModule } from '@tytapp/user';
import { ChatModule } from '@tytapp/chat/chat.module';
import { ArticlesModule } from '@tytapp/articles';
import { AllArticlesComponent } from './all-articles/all-articles.component';
import { MatIconModule } from '@angular/material/icon';

const COMPONENTS = [
    ArticleComponent,
    ArticlesComponent,
    AllArticlesComponent
];
@NgModule({
    imports: [
        FormsModule,
        ACommonModule,
        TYTCommonModule,
        CommonUiModule,
        MediaPlaybackModule,
        UserModule,
        ChatModule,
        ArticlesModule,
        MatIconModule,

        routing
    ],
    declarations: COMPONENTS,
    providers: [
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ArticlePagesModule {
    static forRoot(): ModuleWithProviders<ArticlePagesModule> {
        return {
            ngModule: ArticlePagesModule,
            providers: []
        };
    }
}
